<template>
  <div class="modal-body">
    <template v-if="loader">
      <Loader />
    </template>
    <div class="modal-content">
      <div class="header-config">
        <div>
          <img :src="require('@/assets/background/refresh.svg')" alt="update token" />
        </div>
        <div class="title-close">
          <span>Update Token</span>
          <span @click="closeConfig()">x</span>
        </div>
      </div>
      <div class="infos">
        <label>Refresh Token</label>
        <textarea
          spellcheck="false"
          :class="{ 'active': cHaveRefresh.length < 1 && start }"
          v-model="refresh"
        ></textarea>
      </div>
      <div class="infos">
        <label>Access Token</label>
        <textarea
          spellcheck="false"
          class="access"
          :class="{ 'active': cHaveAccess.length < 1 && start }"
          v-model="access"
        ></textarea>
      </div>
      <div class="position-button">
        <button type="button" @click="submit()">Save</button>
      </div>
      <template v-if="message">
        <div class="success"><span>{{ message }}</span></div>
      </template>
    </div>
  </div>
</template>
<script>
import Loader from '../Loader/Loader.vue';

export default {
  name: 'modal-config-quickbooks',
  data() {
    return {
      access: '',
      refresh: '',
      start: false,
      message: '',
      loader: false,
    };
  },
  components: {
    Loader,
  },
  methods: {
    closeConfig() {
      this.$emit('closeConfig', false);
    },
    async submit() {
      try {
        this.start = true;
        if (this.access.length > 0 && this.refresh.length > 0) {
          this.loader = true;
          const body = {
            access_token: this.access,
            refresh_token: this.refresh,
          };
          const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          };
          const { data: response } = await this.$http.post(
            '/v1/quickbooks/quickbooks-save-config', body, { headers },
          );
          if (response.status === 200) {
            this.access = '';
            this.refresh = '';
            this.start = false;
            this.loader = false;
            this.message = 'Sucess';
            setTimeout(() => {
              this.message = '';
            }, 3000);
          }
        }
      } catch (error) {
        this.loader = false;
        console.error(error);
      }
    },
  },
  computed: {
    cHaveRefresh() {
      if (this.refresh) {
        return this.refresh;
      }
      return '';
    },
    cHaveAccess() {
      if (this.access) {
        return this.access;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.title-close {
  width: 100%;
  display: flex;
  padding: 0 15px;
  align-items: center;
  justify-content: space-between;
}
.modal-body {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  padding-top: 24vh;
  z-index: 9;
  background-color: rgba(61, 150, 219, 0.1);
  backdrop-filter: blur(6px);
  border-radius: 5px;
  .success {
    background-color: $backgroundPayed;
    color: $payed;
    width: 94%;
    margin: 0 auto;
    margin-bottom: 15px;
    font-weight: bold;
    padding: 5px;
  }
  .modal-content {
    min-width: 200px;
    background-color: $white;
    @media(max-width: 960px) {
      width: 90vw;
    }
    .position-button {
      display: flex;
      justify-content: flex-end;
      button {
      padding: 5px 10px;
      height: 47px;
      width: 107px;
      background-color: #0C669C;
      border-radius: 50px;
      color: $white;
      margin-bottom: 10px;
      margin-right: 20px;
      outline: none;
      font-weight: bold;
      @media(max-width: 960px) {
        margin-top: 15px;
      }
    }
    }
    .infos {
      display: flex;
      align-items: center;
      max-width: 620px;
      @media(max-width: 960px) {
        flex-direction: column;
      }
    }
    label {
      color: #0C669C;
      margin: 15px 0;
      width: 30%;
      font-weight: bold;
      margin-right: 5px;
      @media(max-width: 960px) {
      width: 100%;
      }
    }
    textarea {
      // display: flex;
      // max-width: 450px;
      width: 60%;
      margin: 15px 0;
      padding: 3px 5px;
      min-height: 50px;
      background-color: $backgroundData;
      outline: none;
      border-radius: 5px;
      font-size: .8rem;
      border: 1px solid #B0BAC9;
      &.access {
        height: 100px;
      }
      &.active {
        border-radius: 5px;
        border: 1px solid red;
      }
      @media(max-width: 960px) {
        width: 95%;
        margin: 0 auto;
      }
    }
    .header-config {
      width: 100%;
      display: flex;
      background-color: #DCEEFF;
      color: #0C669C;
      font-weight: bold;
      font-size: 1.2rem;
      border-radius: 5px 5px 0 0;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
